<template>
  <div v-if="device ==='pc'" class="box">
    <div class="tip" v-if="type === 'home'">
      <div class="title">找实验室</div>
      <div class="msg">
        我们拥有2万平自有实验室<br />以及200家联合实验室，满足您的检测需求
      </div>
    </div>
    <div>
      <span>检测类型:</span>
      <el-select v-model="checkType" class="select">
        <el-option v-for="(item, index) in typeList" :key="index" :value="item.detectionTypeId" :label="item.detectionTypeName"></el-option>
      </el-select>
    </div>
    <div>
      <span>所在地域:</span>
      <el-select v-model="checkArea" class="select">
        <el-option v-for="(item, index) in areaList" :key="index" :value="item.detectionAreaId" :label="item.detectionAreaName"></el-option>
      </el-select>
    </div>
    <el-button type="primary" id="search-lab" class="btn" v-if="type === 'home'" @click="goToSearchPage">立即查找></el-button>
    <el-button type="primary" id="search-lab" class="btn" v-if="type === 'normal'" @click="handleEmitQuery">重新查找></el-button>
  </div>
  <div v-else>
    <van-cell-group>
      <van-field size="large" label-class="ph-label-style" :value="checkTypeData.detectionTypeName" readonly label="检测类型" placeholder="请选择检测类型" right-icon="arrow" @click="pickerShow=true;pickType='type'" />
      <van-field size="large" @click="pickerShow=true;pickType='area'" label-class="ph-label-style" :value="checkAreaData.detectionAreaName" readonly label="所在地域" placeholder="请选择所在地域" right-icon="arrow" />
    </van-cell-group>
    <div class="ph-query-btn" @click="handleEmitPhQuery">{{hasQueryed?'重新':'立即'}}搜索</div>
    <div class="ph-select-box" v-show="pickerShow">
      <van-overlay :show="pickerShow" />
      <van-picker v-if="pickType==='type'" class="picker" title="检测类型" show-toolbar :columns="typeList" value-key="detectionTypeName" @confirm="onSelectConfirm" @cancel="pickerShow=false" />
      <van-picker v-if="pickType==='area'" class="picker" title="所在地域" show-toolbar :columns="areaList" value-key="detectionAreaName" @confirm="onSelectConfirm" @cancel="pickerShow=false" />
    </div>

  </div>
</template>

<script>
export default {
  name: "laboratoryQuerySelect",
  components: {},
  computed: {},
  props: {
    device: {
      type: String,
      default: "pc",
    },
    type: {
      type: String,
      default: "normal",
    },
    defaultData: {
      type: Object
    }
  },
  data () {
    return {
      checkType: "",
      checkArea: "",
      checkTypeData: { detectionTypeId: '', detectionTypeName: "" },
      checkAreaData: { detectionAreaId: '', detectionAreaName: "" },
      typeList: [

      ],
      areaList: [

      ],
      pickerShow: false,
      pickType: 'type',
      hasQueryed: false
    };
  },
  created () {
    this.getData();
    if (this.defaultData) {
      this.checkType = this.defaultData.type
      this.checkArea = this.defaultData.area
    }
  },
  methods: {
    getData () {
      this.$api.iotHome.getDetectionAndConditionData().then((res) => {
        if (res.data.success == true) {
          this.typeList = res.data.data.detectionTypeList;
          this.areaList = res.data.data.detectionAreaList;
        }
      });
    },
    checkData () {
      this.$message.closeAll()
      if (!this.checkType) {
        this.$message({
          showClose: false,
          message: "请选择检查类型！",
          type: "warning",
          duration: "3000",
        });
        return false;
      }
      if (!this.checkArea) {
        this.$message({
          showClose: false,
          message: "请选择所在地域！",
          type: "warning",
          duration: "3000",
        });
        return false;
      }
      return true
    },
    checkPhData () {
      this.$notify.closeAll()
      if (!this.checkTypeData.detectionTypeId) {
        this.$notify({
          message: '请选择检查类型！',
          // position: 'top-left',
          type: 'warning',
          offset: 100
        })
        return false;
      }
      if (!this.checkAreaData.detectionAreaId) {
        this.$notify({
          message: '请选择所在地域！',
          // position: 'top-left',
          type: 'warning',
          offset: 100
        })
        return false;
      }
      return true
    },
    goToSearchPage () {
      if (!this.checkData()) {
        return
      }
      this.$router.push({
        path: "/laboratorySearch",
        query: { type: this.checkType, area: this.checkArea },
      });
    },
    handleEmitQuery () {
      if (!this.checkData()) {
        return
      }
      this.hasQueryed = true
      this.$emit('query', { type: this.checkType, area: this.checkArea })
    },
    onSelectConfirm (data) {
      if (this.pickType === 'type') {
        this.checkTypeData = data
      } else {
        this.checkAreaData = data
      }
      this.pickerShow = false
    },
    handleEmitPhQuery () {
      if (!this.checkPhData()) {
        return
      }
      this.hasQueryed = true
      this.$emit('query', { type: this.checkTypeData.detectionTypeId, area: this.checkAreaData.detectionAreaId })
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  height: 80px;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  color: #f3f6f7;
  justify-content: center;
  align-items: center;
}
::v-deep.select {
  width: 150px;
  margin: 0 20px;
  .el-input__inner {
    width: 150px !important;
    height: 30px !important;
  }
  .el-input__icon {
    line-height: 30px !important;
  }
}
::v-deep.btn {
  height: 30px;
  padding-top: 7px;
  background-color: #4064ff;
  border-color: #4064ff;
}
.tip {
  position: relative;
  width: 536px;
  padding-left: 178px;
  .title {
    width: 159px;
    height: 90px;
    position: absolute;
    top: -29px;
    left: 0px;
    background: url("~@/assets/laboratory/find.png") no-repeat;
    line-height: 90px;
    text-align: center;
    font-size: 28px;
    font-weight: bold;
    color: #f3f6f7;
    font-style: italic;
  }
  .msg {
    color: #f3f6f7;
    font-size: 14px;
  }
}
.ph-select-box {
  height: 50%;
  width: 100%;
  position: fixed;
  z-index: 999999999;
  bottom: 0;
  left: 0;
  .picker {
    z-index: 99;
    height: 100%;
  }
}
.ph-query-btn {
  height: 0.8rem;
  line-height: 0.8rem;
  background: #14255d;
  border-radius: 2px;
  font-size: 15px;
  color: #ffffff;
  margin-top: 0.6rem;
}
</style>
<style lang="scss">
.ph-label-style {
  span {
    color: #282b45;
  }
}
</style>
